import styled from 'styled-components';

export const CarouselNavigator = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0.555vw 5.555vw 0 5.555vw;

  .dotsNavigationWrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    vertical-align: middle;
    gap: 8px;
    
    @media (max-width: 991px) {
      margin-left: auto;
      margin-right: auto;
    }
  }

  .buttonsNavigationWrapper {
    display: flex;
    flex-direction: row;

    .prev_slide,
    .next_slide {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      border: 1.5px solid #FFFFFF;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
      border-radius: 50%;
      width: 24px;
      height: 24px;
      margin: 0 4px;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;

      &.disabled {
        opacity: 0.5;
        cursor: no-drop;
      }

      svg {
        user-select: none;
        width: 16px;
        height: 16px;
      }

      &:hover {
        background: #FFFFFF;
        border: 1.5px solid #FFFFFF;
        .arrow {
          path {
            stroke: #7F7F7F;
          }
        }
      }
    }

    .prev_slide {
      padding-right: 6px;
    }

    .next_slide {
      padding-left: 2px;
    }
  }

  @media (min-width: 992px) and (max-width: 1439px) {
    margin-top: 8px;
  }
  
  @media (max-width: 991px) {
    margin: 24px auto 0 auto;
    .buttonsNavigationWrapper {
      display: none;
    }
  }
`;

export const Dot = styled.div`
  background-color: #FFF;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  opacity: ${props => props.active ? 1 : 0.5};
  @media (max-width: 991px) {
    background-color: #CBFA05;
    height: 6px;
    width: 6px;
  }
`;

export const PostCardStyled = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  background-size: cover;
  width: ${props => `calc(0.28889 * ${props.windowWidth}px)`};
  height: ${props => `calc(0.28889 * ${props.windowWidth}px)`};
  background-image: ${props => `url(${props.image})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .postOverlay {
    width: 100%;
    height: 100%;
    background: linear-gradient(360deg, #000 0%, rgba(0, 0, 0, 0) 59.91%);
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .postTextWrapper {
      height: 28%;

      .postTitle {
        font-weight: 500;
        line-height: 2.29vw;
        letter-spacing: 0em;
        text-align: left;
        color: #fff;
        font-family: 'Hind Madurai', sans-serif;
        font-size: 1.666vw;
        margin-bottom: 8px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;


        @media (max-width: 576px) {
          font-size: 4.61vw;
          line-height: 6.369vw;
        }
      }
    }

    .postLinkWrapper {
      display: flex;
      align-items: center;

      .postLink {
        font-size: 0.83vw;
        line-height: 1.11vw;
        letter-spacing: 0.05em;
        font-weight: 500;
        margin-right: 6px;
        color: #CBFA05;
        text-decoration: none;
        font-family: 'Hind Madurai', sans-serif;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        max-height: 3.6em;

        @media (max-width: 576px) {
          font-size: 3.07vw;
          line-height: 4.102vw;
        }
      }
      
      .arrowLeft {
        font-size: 0.83vw;
        line-height: 0.69vw;

        @media (max-width: 576px) {
          width: 3.07vw;
          height: 2.56vw;
        }
      }
    }
  }

  @media (max-width: 576px) {
    height: 87.7vw !important;
    width: 100%;    
  }
`;

export const PostBlocWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
`;